import React from 'react'
import emailjs from 'emailjs-com'
import styled from 'styled-components'
import theme from '../../themes';
// import 'bootstrap/dist/css/bootstrap.css'


const InputContainer = styled.input`
width:100%;
height:100%;
border-radius:5px;
padding:10px;
/* border:.5px solid ${theme.primary}; */
margin-bottom:10px;

@media screen and (max-width:480px){
    width:100%;
    height:100%;

}

`

const Form = styled.form`
margin-top:1px;
padding:1px;



`
const TextArea = styled.textarea`
width:100%;
height:100%;
border-radius:5px;
padding:5px;
/* border:0.2px solid ${theme.primary}; */
margin-bottom:10px;

@media screen and (max-width:480px){
    width:100%;
    height:100%;

}
`


function ContactUs(){

    function sendEmail(e){
        e.preventDefault();

        emailjs.sendForm('service_lkqe71g', 'template_246wh2a', e.target, 'user_pfSudi4gYJ8MYT7yZd5QM')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset()
          
    }
    return(
        <div>
            <div className="container-fluid">
                <Form action="" onSubmit={sendEmail}>
                    <h6 style={{textAlign:"center",color:"#000080"}}>Get in touch with us</h6>
                    <div className="row pt-5 mx-auto p-10">
                        <div className="col-12 form-group mx-auto">
                            <InputContainer type="text" className="form-control" style={{width:"100%"}} placeholder="Name" name="name"/>
                        </div>
                        <div className="col-12 form-group pt-2 mx-auto">
                            <InputContainer type="email" className="form-control"style={{width:"100%"}} placeholder="Email Address" name="email"/>
                        </div>
                        <div className="col-12 form-group pt-2 mx-auto">
                            <InputContainer type="text" className="form-control"style={{width:"100%"}} placeholder="Subject" name="subject"/>
                        </div>
                        <div className="col-12 form-group pt-1 mx-auto">
                            <TextArea className="form-control" id="" rows="5" cols="3" placeholder="Your message" name="message"></TextArea>
                        </div>
                        <div className="col-12 pt-3 mx-auto">
                            <InputContainer type="submit" style={{cursor:"pointer",backgroundColor:"navy",color:"#fff",padding:"10px",borderRadius:"5px"}} className="btn btn-info" value="Send Message" />
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default ContactUs


